const ROWS = [
  ["Q", "W", "E", "R", "T", "Y", "U", "I", "O", "P"],
  ["A", "S", "D", "F", "G", "H", "J", "K", "L", "BACKSPACE"],
  ["Z", "X", "C", "V", "B", "N", "M"],
];
const COLORS = {
  verde: "#10b981",
  amarelo: "#f59e0b",
  cinza: "#374151",
};

export function GameKeyboard({
  aoDigitar,
  estadoTeclas = {},
  mostrarEspaco = false,
}) {
  const rows = [
    ROWS[0],
    ROWS[1],
    [...ROWS[2], ...(mostrarEspaco ? ["SPACE"] : []), "ENTER"],
  ];

  return (
    <div className="teclado-container">
      {rows.map((row, index) => (
        <div className="teclado-linha" key={index}>
          {row.map((key) => {
            const enter = key === "ENTER";
            const backspace = key === "BACKSPACE";
            const space = key === "SPACE";
            return (
              <button
                onClick={() => aoDigitar(key)}
                className={`tecla-btn ${enter || backspace || space ? "tecla-special" : ""} ${space ? "tecla-space" : ""}`}
                style={{
                  backgroundColor: COLORS[estadoTeclas[key]] || "#1f2937",
                }}
                aria-label={
                  backspace
                    ? "Apagar"
                    : space
                      ? "Espaço"
                      : enter
                        ? "Próxima categoria"
                        : key
                }
                type="button"
                key={key}
              >
                {backspace ? "⌫" : space ? "ESPAÇO" : key}
              </button>
            );
          })}
        </div>
      ))}
    </div>
  );
}
